module.exports = __webpack_public_path__ + "img/lw-logo-a.0ab90881.jpg";